import { motion } from "framer-motion";

const partners: { name: string; color: string; icon: string }[] = [
  { name: "Binance", color: "#F0B90B", icon: "₿" },
  { name: "Coinbase", color: "#0052FF", icon: "◎" },
  { name: "Kraken", color: "#5741D9", icon: "🐙" },
  { name: "Bitfinex", color: "#16B157", icon: "◆" },
  { name: "Gemini", color: "#00DCFA", icon: "♊" },
  { name: "KuCoin", color: "#23AF91", icon: "▲" },
  { name: "Huobi", color: "#1F6CED", icon: "🔥" },
  { name: "OKX", color: "#FFFFFF", icon: "⬡" },
  { name: "Bybit", color: "#F7A600", icon: "⚡" },
  { name: "Gate.io", color: "#2354E6", icon: "🚪" },
  { name: "Bitstamp", color: "#4FAD4F", icon: "🟢" },
  { name: "Crypto.com", color: "#002D74", icon: "🛡" },
  { name: "eToro", color: "#6AB04C", icon: "📈" },
  { name: "Robinhood", color: "#00C805", icon: "🪶" },
  { name: "Bittrex", color: "#066FC1", icon: "◈" },
  { name: "Poloniex", color: "#00D395", icon: "⬢" },
  { name: "BitMEX", color: "#FF0000", icon: "✕" },
  { name: "Deribit", color: "#01C2A0", icon: "◇" },
  { name: "FTX", color: "#02A6C2", icon: "Ⓕ" },
  { name: "Upbit", color: "#093687", icon: "▼" },
  { name: "Bithumb", color: "#F37321", icon: "🔶" },
  { name: "Luno", color: "#0091FF", icon: "☽" },
  { name: "Paxful", color: "#00A5EF", icon: "🤝" },
  { name: "LocalBitcoins", color: "#F7931A", icon: "📍" },
  { name: "CEX.IO", color: "#0B7AEE", icon: "Ⓒ" },
  { name: "Bitvavo", color: "#183F73", icon: "◉" },
  { name: "Bitpanda", color: "#1A4740", icon: "🐼" },
  { name: "SwissBorg", color: "#01C38D", icon: "🏔" },
  { name: "BlockFi", color: "#694ED6", icon: "■" },
  { name: "Nexo", color: "#1A4199", icon: "Ⓝ" },
  { name: "Celsius", color: "#4B3F99", icon: "°" },
  { name: "Voyager", color: "#5F3DC4", icon: "🚀" },
  { name: "CoinEx", color: "#45B26B", icon: "Ⓧ" },
  { name: "MEXC", color: "#1972E2", icon: "Ⓜ" },
  { name: "BitMart", color: "#00C3A5", icon: "★" },
  { name: "Phemex", color: "#4F6EF7", icon: "⟁" },
  { name: "WazirX", color: "#5A5FE0", icon: "Ⓦ" },
  { name: "CoinDCX", color: "#3B82F6", icon: "◐" },
  { name: "ZebPay", color: "#12B886", icon: "🦓" },
  { name: "BuyUcoin", color: "#F4A100", icon: "₹" },
  { name: "Swyftx", color: "#0070F3", icon: "⚡" },
  { name: "Independent Reserve", color: "#1E90FF", icon: "🇦🇺" },
  { name: "BTC Markets", color: "#2B9348", icon: "₿" },
  { name: "CoinSpot", color: "#F5A623", icon: "●" },
  { name: "CoinJar", color: "#0066FF", icon: "🫙" },
  { name: "Shakepay", color: "#0066FF", icon: "🍁" },
  { name: "Newton", color: "#00D68F", icon: "Ⓝ" },
  { name: "Bitbuy", color: "#2563EB", icon: "🅱" },
  { name: "NDAX", color: "#004FFF", icon: "▷" },
  { name: "Coinsquare", color: "#3B7DDD", icon: "□" },
];

const PartnersSection = () => {
  return (
    <section className="py-24 bg-card/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">
            Our Partners
          </h2>
          <p className="mt-4 text-muted-foreground font-body text-lg">
            Integrated with the world's leading exchanges and platforms.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-12 flex flex-wrap items-center justify-center gap-3"
        >
          {partners.map((p) => (
            <div
              key={p.name}
              className="group flex items-center gap-2 rounded-xl border border-border bg-card/80 px-4 py-2.5 text-sm font-body transition-all hover:scale-105 hover:shadow-lg"
              style={{
                borderColor: `${p.color}30`,
              }}
            >
              <span
                className="flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold"
                style={{ backgroundColor: `${p.color}20`, color: p.color }}
              >
                {p.icon}
              </span>
              <span className="text-muted-foreground group-hover:text-foreground transition-colors font-medium">
                {p.name}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PartnersSection;
